// extracted by mini-css-extract-plugin
export default {"upload":"UploadButton_upload","uploadPending":"UploadButton_uploadPending UploadButton_upload","uploadIcon":"UploadButton_uploadIcon"};